









































	import {Prop, Watch} from "vue-property-decorator";
	import {Stored} from 'vue-stored-prop-decorator';
	import {Component, Vue} from '@/shared/component';
	import {Timeout, WatchObjectProperties} from '@/shared/decorator';

	import {
		storeEssenceAchatsRecherche,
		EssenceAchatFilter,
		storeEssenceAchatsTotaux
	} from '@/stores/modules/essenceAchat';

	import InputDateFilter from '@/components/Input/DateFilter.vue';
	import CrudTransporteurSearch from "@/components/Crud/Transporteur/Search.vue";
	import InputBoisType from "@/components/Input/BoisType.vue";
	import {DateFilterMode} from "@/shared/filter";
	import InputLongueursAchat from "@/components/Input/LongueursAchat.vue";

	@Component({
		components: {
			InputDateFilter,
			InputBoisType,
			InputLongueursAchat,
			CrudTransporteurSearch,
		}
	})
	export default class CrudEssenceAchatFilterRechercheEssenceAchats extends Vue {

		@Prop({ type: Boolean, default: false}) reduce!: boolean;

		@Stored(() => storeEssenceAchatsRecherche) private page!: number;
		@Stored(() => storeEssenceAchatsRecherche) private filters!: EssenceAchatFilter;

		@WatchObjectProperties('filters', EssenceAchatFilter)
		@Timeout()
		private filtersWatcher(): void {
			this.page = 0;
			storeEssenceAchatsRecherche.dispatch( 'getRechercheEssenceAchats', { filters: false });
		}
		
		public mounted() {
		    this.typeWatcher();
		}

	    @Watch('type')
		private typeWatcher(): void {
            this.filters.clear();

		}

		private get methodName(): string {
			return 'getRechercheEssenceAchats';
		}

		@Watch('order')
		@Watch('page')
		@Watch('direction')
		private refresh(): void {
			storeEssenceAchatsRecherche.dispatch(this.methodName, { filters: true });
		}

	}
